"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeFormData = exports.makeURLSearchParams = exports.deleteWithCsrfToken = exports.formUrlEncodedToObject = exports.postWithCsrfTokenJson = exports.postWithCsrfTokenFormData = exports.postWithCsrfToken = exports.postJson = exports.post = exports.getJsonWebToken = exports.getCsrfToken = exports.get = exports.setDatadogLogger = void 0;
/**
 * This module contains wrappers for requests to the Hub
 */
var axios_1 = __importDefault(require("axios"));
var ApplicationError_1 = require("./ApplicationError");
var dev_performance_1 = __importDefault(require("./store/dev.performance"));
var stopwatch_1 = __importDefault(require("./util/stopwatch"));
var datadogLogger;
function setDatadogLogger(v) {
    datadogLogger = v;
}
exports.setDatadogLogger = setDatadogLogger;
// const httpsAgent = new https.Agent({ rejectUnauthorized: false });
/**
 * make HTTP request
 *
 * @param {object} axios - axios instance
 * @param {object} config - axios request config object
 * @param {number} timeout - (opt.) request timeout in milliseconds
 * @param {boolean} ajaxHeader - (opt.) set 'X-Requested-With' header to 'XMLHttpRequest'
 * @param {boolean} withCredentials - (opt.) cross-site Access-Control requests include credentials
 * @param {cancelToken} Axios.CancelToken - (opt.) axios cancel token
 */
function makeRequest(axios, config, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.timeout, timeout = _c === void 0 ? 600000 : _c, _d = _b.prefix, prefix = _d === void 0 ? "" : _d, _e = _b.ajaxHeader, ajaxHeader = _e === void 0 ? true : _e, _f = _b.withCredentials, withCredentials = _f === void 0 ? true : _f, _g = _b.cancelToken, cancelToken = _g === void 0 ? null : _g, _h = _b.tpsDotNet, tpsDotNet = _h === void 0 ? false : _h, _j = _b.raw, raw = _j === void 0 ? false : _j, _k = _b.anonymousHeader, anonymousHeader = _k === void 0 ? null : _k, _l = _b.jwt, jwt = _l === void 0 ? null : _l, _m = _b.shareLink, shareLink = _m === void 0 ? null : _m;
    return __awaiter(this, void 0, void 0, function () {
        var datadogSession, sw, now, secs, response, now, secs, error_1;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    config.timeout = timeout;
                    config.withCredentials = withCredentials;
                    if (cancelToken)
                        config.cancelToken = cancelToken;
                    if (tpsDotNet)
                        config.url = "/tps".concat(config.url);
                    else if (prefix)
                        config.url = "/".concat(prefix).concat(config.url);
                    else if (!raw)
                        config.url = "/classic".concat(config.url);
                    if (!config.headers)
                        config.headers = {};
                    if (ajaxHeader)
                        config.headers["X-Requested-With"] = "XMLHttpRequest";
                    config.headers["X-Anonymous-Header"] = anonymousHeader;
                    datadogSession = datadogLogger === null || datadogLogger === void 0 ? void 0 : datadogLogger.session;
                    if (datadogSession) {
                        config.headers["X-Datadog-Session-Id"] = datadogSession.getId();
                    }
                    if (config.withCredentials) {
                        if (!config.headers)
                            config.headers = {};
                        if (jwt)
                            config.headers["Authorization"] = "Bearer ".concat(jwt);
                    }
                    if (shareLink) {
                        if (!config.headers)
                            config.headers = {};
                        config.headers["X-Tps-Sharelink"] = shareLink;
                    }
                    config.headers["X-Tps-Origin"] =
                        typeof window === "undefined" ? "" : window.location.origin;
                    _o.label = 1;
                case 1:
                    _o.trys.push([1, 3, , 4]);
                    sw = !dev_performance_1.default.enablePerformanceLogging() ? undefined : new stopwatch_1.default();
                    if (sw) {
                        now = new Date();
                        secs = (now.getSeconds() + now.getMilliseconds() / 1000).toFixed(3);
                        // eslint-disable-next-line no-console
                        console.log("".concat(secs, " ").concat(config.method.toUpperCase(), " starts ").concat(config.url));
                    }
                    return [4 /*yield*/, axios.request(config)];
                case 2:
                    response = _o.sent();
                    if (sw) {
                        now = new Date();
                        secs = (now.getSeconds() + now.getMilliseconds() / 1000).toFixed(3);
                        // eslint-disable-next-line no-console
                        console.log("".concat(secs, " ").concat(config.method.toUpperCase(), " ").concat(sw.ms(), " ").concat(config.url));
                    }
                    return [2 /*return*/, response];
                case 3:
                    error_1 = _o.sent();
                    // see axios docs
                    if (error_1.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        switch (error_1.response.status) {
                            case 400:
                                throw new ApplicationError_1.ApplicationError(ApplicationError_1.ErrorCode.HTTP_BAD_REQUEST, "HTTP error status: 400 Bad Request", error_1);
                            case 401:
                                throw new ApplicationError_1.ApplicationError(ApplicationError_1.ErrorCode.AUTHORIZATION, "HTTP error status: 401 Unauthorized", error_1);
                            case 404:
                                throw new ApplicationError_1.ApplicationError(ApplicationError_1.ErrorCode.HTTP_ERROR_404_NOT_FOUND, "HTTP error status: 404 Not Found", error_1);
                            case 403:
                                throw new ApplicationError_1.ApplicationError(ApplicationError_1.ErrorCode.HTTP_FORBIDDEN, "HTTP error status: 403 Forbidden", error_1);
                        }
                        throw new ApplicationError_1.ApplicationError(ApplicationError_1.ErrorCode.HTTP_ERROR_RESPONSE, "Error response status", error_1);
                    }
                    if (cancelToken && axios_1.default.isCancel(error_1)) {
                        throw new ApplicationError_1.ApplicationError(ApplicationError_1.ErrorCode.CANCELLED, "Request cancelled", error_1.message);
                    }
                    if (error_1.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                        // if (appIntercept) {
                        //   const r = await AppService.Invoke((o: any) => o.axiosOffline([config]));
                        //   console.log(`axiosOffline ${config.url} => `, r);
                        //   if (r.success) return { data: r.data };
                        // }
                        throw new ApplicationError_1.ApplicationError(ApplicationError_1.ErrorCode.HTTP_NO_RESPONSE, "Unknown HTTP request failure", error_1);
                    }
                    // Something happened in setting up the request that triggered an Error
                    throw ApplicationError_1.ApplicationError.Unexpected({ message: "makeRequest", error: error_1 });
                case 4: return [2 /*return*/];
            }
        });
    });
}
/**
 * GET HTTP request
 *
 * @param {object} axios - axios instance
 * @param {string} url - url of the endpoint to call
 * @param {number} timeout - (opt.) request timeout in milliseconds
 * @param {boolean} ajaxHeader - (opt.) set 'X-Requested-With' header to 'XMLHttpRequest'
 * @param {boolean} withCredentials - (opt.) cross-site Access-Control requests include credentials
 */
function get(axios, url, requestOptions) {
    if (requestOptions === void 0) { requestOptions = {}; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, makeRequest(axios, { method: "get", url: url }, requestOptions)];
        });
    });
}
exports.get = get;
/**
 * Post a request to '/AntiForgery' to get a CSRF token
 *
 * @param {object} axios - axios instance
 */
var csrfToken = null;
var csrfTimestamp = null;
var csrfRequest = null;
function getCsrfToken(axios, refresh) {
    if (refresh === void 0) { refresh = false; }
    return __awaiter(this, void 0, void 0, function () {
        var ms, secs, response, m, token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!refresh && csrfToken && csrfTimestamp) {
                        ms = Date.now() - csrfTimestamp;
                        secs = ms / 1000;
                        if (secs < 60)
                            return [2 /*return*/, csrfToken];
                    }
                    if (!csrfRequest)
                        csrfRequest = makeRequest(axios, { method: "post", url: "/AntiForgery" }, { tpsDotNet: true });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, csrfRequest];
                case 2:
                    response = _a.sent();
                    m = void 0, token = void 0;
                    if ((m = /value="(.*)"/gm.exec(response.data)) !== null) {
                        token = m[1];
                    }
                    else {
                        throw new ApplicationError_1.ApplicationError(ApplicationError_1.ErrorCode.GENERIC, "Failed to get CSRF token");
                    }
                    csrfToken = token;
                    csrfTimestamp = Date.now();
                    return [2 /*return*/, token];
                case 3:
                    csrfRequest = null;
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getCsrfToken = getCsrfToken;
/**
 * Post a request to '/UserAccount/GetJsonWebToken'
 *
 * @param {object} axios - axios instance
 */
var jwtToken = false;
var jwtTimestamp = null;
function getJsonWebToken(axios, refresh) {
    if (refresh === void 0) { refresh = false; }
    return __awaiter(this, void 0, void 0, function () {
        var ms, secs, anHour, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!refresh && jwtToken && jwtTimestamp) {
                        ms = Date.now() - jwtTimestamp;
                        secs = ms / 1000;
                        anHour = 1 * 60 * 60;
                        if (secs < anHour)
                            return [2 /*return*/, jwtToken];
                    }
                    return [4 /*yield*/, post(axios, "/UserAccount/GetJsonWebToken", {}, { tpsDotNet: true })];
                case 1:
                    response = _a.sent();
                    jwtToken = response.data.jwt;
                    jwtTimestamp = Date.now();
                    return [2 /*return*/, jwtToken];
            }
        });
    });
}
exports.getJsonWebToken = getJsonWebToken;
/**
 * Post a request to an endpoint
 *
 * @param {object} axios - axios instance
 * @param {string} url - url of the endpoint to call
 * @param {object} dict - form parameters in the format: { property1: value, property2: value }
 * @param {number} timeout - (opt.) request timeout in milliseconds
 * @param {boolean} ajaxHeader - (opt.) set 'X-Requested-With' header to 'XMLHttpRequest'
 * @param {boolean} withCredentials - (opt.) cross-site Access-Control requests include credentials
 */
function post(axios, url, dict, requestOptions) {
    if (dict === void 0) { dict = {}; }
    if (requestOptions === void 0) { requestOptions = {}; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, postJson(axios, url, dict, requestOptions)];
        });
    });
}
exports.post = post;
/**
 * Post a request to an endpoint
 *
 * @param {object} axios - axios instance
 * @param {string} url - url of the endpoint to call
 * @param {object} dict - form parameters in the format: { property1: value, property2: value }
 * @param {number} timeout - (opt.) request timeout in milliseconds
 * @param {boolean} ajaxHeader - (opt.) set 'X-Requested-With' header to 'XMLHttpRequest'
 * @param {boolean} withCredentials - (opt.) cross-site Access-Control requests include credentials
 */
function postJson(axios, url, dict, requestOptions) {
    if (requestOptions === void 0) { requestOptions = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            config = {
                method: "post",
                url: url,
                data: dict,
                headers: {},
            };
            return [2 /*return*/, makeRequest(axios, config, requestOptions)];
        });
    });
}
exports.postJson = postJson;
/**
 * Post a request to an endpoint adding the CSRF token in the body or header of the request
 *
 * @param {object} axios - axios instance
 * @param {string} url - url of the endpoint to call
 * @param {object} dict - form parameters in the format: { property1: value, property2: value }
 * @param {string} csrfToken - (opt.) CSRF token
 * @param {boolean} useHeader - (opt.) if true the token is put as header
 * @param {number} timeout - (opt.) request timeout in milliseconds
 * @param {boolean} ajaxHeader - (opt.) set 'X-Requested-With' header to 'XMLHttpRequest'
 * @param {boolean} withCredentials - (opt.) cross-site Access-Control requests include credentials
 * @param {boolean} dictAsFormData - (opt.) treat dict as an instance of FormData
 */
function postWithCsrfToken(axios, url, dict, requestOptions, headers) {
    if (requestOptions === void 0) { requestOptions = {}; }
    if (headers === void 0) { headers = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var config, requestVerificationToken, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    config = {
                        method: "post",
                        url: url,
                        // data: params,
                        data: dict,
                        headers: headers,
                    };
                    _a = requestOptions.csrfToken;
                    if (_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, getCsrfToken(axios)];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    requestVerificationToken = _a;
                    config.headers["X-Request-Verification-Token"] = requestVerificationToken;
                    // if (!requestOptions.useHeader) {
                    //   params.append("__RequestVerificationToken", requestVerificationToken);
                    // }
                    return [2 /*return*/, makeRequest(axios, config, requestOptions)];
            }
        });
    });
}
exports.postWithCsrfToken = postWithCsrfToken;
/**
 * Post a request to an endpoint adding the CSRF token in the body or header of the request
 *
 * @param {object} axios - axios instance
 * @param {string} url - url of the endpoint to call
 * @param {object} dict - form parameters in the format: { property1: value, property2: value }
 * @param {string} csrfToken - (opt.) CSRF token
 * @param {boolean} useHeader - (opt.) if true the token is put as header
 * @param {number} timeout - (opt.) request timeout in milliseconds
 * @param {boolean} ajaxHeader - (opt.) set 'X-Requested-With' header to 'XMLHttpRequest'
 * @param {boolean} withCredentials - (opt.) cross-site Access-Control requests include credentials
 */
function postWithCsrfTokenFormData(axios, url, dict, requestOptions, headers) {
    if (requestOptions === void 0) { requestOptions = {}; }
    if (headers === void 0) { headers = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var params, config, requestVerificationToken, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    params = makeFormData(dict);
                    config = {
                        method: "post",
                        url: url,
                        data: params,
                        headers: headers,
                    };
                    _a = requestOptions.csrfToken;
                    if (_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, getCsrfToken(axios)];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    requestVerificationToken = _a;
                    config.headers["X-Request-Verification-Token"] = requestVerificationToken;
                    if (!requestOptions.useHeader) {
                        params.append("__RequestVerificationToken", requestVerificationToken);
                    }
                    return [2 /*return*/, makeRequest(axios, config, requestOptions)];
            }
        });
    });
}
exports.postWithCsrfTokenFormData = postWithCsrfTokenFormData;
/**
 * Post a request to an endpoint adding the CSRF token in the body or header of the request.
 * Takes an object and serialises to JSON
 *
 * @param {object} axios - axios instance
 * @param {string} url - url of the endpoint to call
 * @param {object} dict - JavaScript object
 * @param {string} csrfToken - (opt.) CSRF token
 * @param {boolean} useHeader - (opt.) if true the token is put as header
 * @param {number} timeout - (opt.) request timeout in milliseconds
 * @param {boolean} ajaxHeader - (opt.) set 'X-Requested-With' header to 'XMLHttpRequest'
 * @param {boolean} withCredentials - (opt.) cross-site Access-Control requests include credentials
 */
function postWithCsrfTokenJson(axios, url, dict, requestOptions) {
    if (requestOptions === void 0) { requestOptions = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var config, requestVerificationToken, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    config = {
                        method: "post",
                        url: url,
                        data: dict,
                        headers: {},
                    };
                    _a = requestOptions.csrfToken;
                    if (_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, getCsrfToken(axios)];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    requestVerificationToken = _a;
                    config.headers["X-Request-Verification-Token"] = requestVerificationToken;
                    return [2 /*return*/, makeRequest(axios, config, requestOptions)];
            }
        });
    });
}
exports.postWithCsrfTokenJson = postWithCsrfTokenJson;
/**
 *
 * @param {string} - www-form-urlencoded parameters (ie: Email=test%40test.com&Value=value123)
 */
function formUrlEncodedToObject(formParams) {
    var o = {};
    for (var _i = 0, _a = formParams.match(/([^?=&]+)(=([^&]*))?/gm) || []; _i < _a.length; _i++) {
        var m = _a[_i];
        var _b = m.split("="), p = _b[0], v = _b[1];
        o[p] = decodeURIComponent(v).replace(/\+/gm, " ");
    }
    return o;
}
exports.formUrlEncodedToObject = formUrlEncodedToObject;
/**
 * Post a request to an endpoint adding the CSRF token in the body or header of the request.
 * Takes an object and serialises to JSON
 *
 * @param {object} axios - axios instance
 * @param {string} url - url of the endpoint to call
 * @param {object} dict - JavaScript object
 * @param {string} csrfToken - (opt.) CSRF token
 * @param {boolean} useHeader - (opt.) if true the token is put as header
 * @param {number} timeout - (opt.) request timeout in milliseconds
 * @param {boolean} ajaxHeader - (opt.) set 'X-Requested-With' header to 'XMLHttpRequest'
 * @param {boolean} withCredentials - (opt.) cross-site Access-Control requests include credentials
 */
function deleteWithCsrfToken(axios, url, dict, requestOptions) {
    if (dict === void 0) { dict = {}; }
    if (requestOptions === void 0) { requestOptions = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var config, requestVerificationToken, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    config = {
                        method: "delete",
                        url: url,
                        data: dict,
                        headers: {},
                    };
                    _a = requestOptions.csrfToken;
                    if (_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, getCsrfToken(axios)];
                case 1:
                    _a = (_b.sent());
                    _b.label = 2;
                case 2:
                    requestVerificationToken = _a;
                    config.headers["X-Request-Verification-Token"] = requestVerificationToken;
                    return [2 /*return*/, makeRequest(axios, config, requestOptions)];
            }
        });
    });
}
exports.deleteWithCsrfToken = deleteWithCsrfToken;
/**
 * Creates an URLSearchParams object given a dictionary ({ property1: value, property2: value })
 *
 * @param {object} dict - form parameters in the format: { property1: value, property2: value }
 */
function makeURLSearchParams(dict) {
    var params = new URLSearchParams();
    if (dict) {
        var pairs = Object.entries(dict);
        var snafu = pairs.filter(function (_a) {
            var key = _a[0], value = _a[1];
            return key && value !== void 0 && value !== null;
        });
        snafu.forEach(function (_a) {
            var key = _a[0], value = _a[1];
            return params.append(key, value);
        });
    }
    return params;
}
exports.makeURLSearchParams = makeURLSearchParams;
/**
 * Creates an FormData object given a dictionary ({ property1: value, property2: value })
 *
 * @param {object} dict - form parameters in the format: { property1: value, property2: value }
 */
function makeFormData(dict) {
    var params = new FormData();
    if (dict) {
        var pairs = Object.entries(dict);
        var snafu = pairs.filter(function (_a) {
            var key = _a[0], value = _a[1];
            return key && value !== void 0 && value !== null;
        });
        snafu.forEach(function (_a) {
            var key = _a[0], value = _a[1];
            return params.append(key, value);
        });
    }
    return params;
}
exports.makeFormData = makeFormData;
//# sourceMappingURL=requestHelpers.js.map